<template>
    <div class="ns-toast_container" :opened="opened" :theme="theme" :type="type" :duration="duration" :icon="icon" :no-icon="noIcon" :show-close-icon="showCloseIcon">
        <div class="toast__scrim" @click="hide"></div>
        <section class="toast">
            <div v-if="!usesCustomSlot" class="responsive-container">
                <div class="responsive-container__inner-container">
                <div class="toast__content toast__content--left">
                    <iron-icon class="toast__icon--status" :icon="iconInUse"></iron-icon>
                    <slot name="toast-content-left"></slot>
                </div>
                <div id="ctaWrapper" class="toast__cta-section toast__content toast__content--right" action-type="login" >
                    <slot name="cta"></slot>
                </div>
                <iron-icon class="toast__icon--close" icon="nuskin:icon-close" @click="hide"></iron-icon>
                </div>
            </div>
            <!-- adding this because toaster is hardcoded to have two columns and there is no option to have one column -->
            <div v-if="usesCustomSlot" class="custom">
                <slot name="custom"></slot>
            </div>
        </section>
    </div>
</template>

<script>
import Vue from 'vue';
import {events} from '@nuskin/ns-util';

const nsToastVue = {
    name: "nsToastVue",
    props: {
        /**
        * How long fleeting toasts should stay on the screen
        */
        duration: {
            type: String,
            default: "3200"
        },
        /**
        * The icon that should be displayed on the left of the toast. Takes a string representing the set and id of the icon
        */
        icon: {
            type: String,
            default: 'nuskin:icon-info-filled'
        },
        /**
        * Hide the icon displayed on the left of the toast
        */
        noIcon: {
            type: Boolean
        },
        /**
        * Determines how the toast should look. Options include: none (default), 'information', 'success', 'warning', 'error'
        */
        theme: {
            type: String
        },
        /**
        * Determines the type of toast. Options include: 'fleeting' (default), 'persistent', 'cta'
        */
        type: {
            type: String,
            default: 'fleeting'
        },
        /**
        * Used to show the close icon on the toast
        */
        showCloseIcon: {
            type: Boolean
        },
        /**
        * Used to register toast to an event to show and hide
        */
        toastEventName: String,
        /**
        * 
        */
        custom: Boolean
    },
    data: function() {
        return {
            /**
            * Indicated the opened or closed state of the toast. You can also set the attribute to open the toast.
            */
            opened: false
        }
    },
    computed: {
        iconInUse: function () {
            if (!this.hasOwnProperty('icon')) {
                switch (this.theme) {
                    case 'information':
                        return 'nuskin-color:icon-info-filled';
                    case 'success':
                        return 'nuskin-color:icon-success-filled';
                    case 'warning':
                        return 'nuskin-color:icon-warning-filled';
                    case 'error':
                        return 'nuskin-color:icon-error-filled';
                    default:
                        return this.icon;
                }
            } else {
                return this.icon
            }
        },
        usesCustomSlot: function() {
            return!!this.$slots.custom
        }
    },
    mounted: function() {
        this.registerEvents();
    },
    methods: {
        /**
        * Display the toast
        */
        show() {
            this.opened = true;
            if (this.type === 'fleeting' || !this.type) {
                setTimeout(() => {
                    this.hide();
                }, Number(this.duration));
            }
        },
        /**
        * Hide the toast
        */
        hide() {
            this.opened = false;
        },
        /**
        * Facade method for show()
        */
        open() { 
            this.show() 
        },
        /**
        * Facade method for hide()
        */
        close() { 
            this.hide() 
        },
        /**
        * Toggle the display of the toast
        */
        toggle() {
            this.opened ? this.hide() : this.show();
        },
        registerEvents() {
            if (this.toastEventName) {
                events.subscribe(this.toastEventName, () => {
                    this.show();
                });
            }

            // need to close the toast if the cta is clicked
            $("#ctaWrapper").click((e) => {
                if(this.type === 'cta') {
                    this.hide();
                }
            });
        }
    }
}

export default nsToastVue;
</script>

<style lang="scss" scoped>
    @use "sass:map";
    @use '~@nuskin/ns-core-styles/src/scss/global.mixins';
    @use '~@nuskin/ns-core-styles/src/scss/colors';
    @use '~@nuskin/ns-core-styles/src/scss/typographyVariables';
    @use '~@nuskin/ns-core-styles/src/scss/other';

    * { box-sizing: border-box; }

    .toast {
        visibility: hidden;
        display: flex;
        align-items: center;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        transform: translateY(120px);
        color: map.get(colors.$themeColors, color-primary-text);
        font-family: map.get(typographyVariables.$typography, font-family-primary);
        border-top: 2px solid map.get(colors.$themeColors, color-interactive-7);
        background-color: #ffffff;
        opacity: 0;
        transition: map.get(other.$otherUtils, global-transition);
        z-index: map.get(other.$otherUtils, z-modal);
    }
    // .ns-toast_container[custom] .toast {
    //     justify-content: center;
    //     width: 100%;
    // }
    .ns-toast_container[opened] .toast {
        visibility: visible;
        opacity: 1;
        transform: translateY(0);
    }
    .toast .responsive-container {
        padding-top: 30px;
        padding-bottom: 30px;
        position: relative;
    }
    .responsive-container__inner-container {
        display: grid;
        grid-gap: 20px;
    }
    .toast__icon--status {
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }
    .toast__content {
        flex: 1;
    }
    .toast__content--left {
        display: flex;
        align-items: center;
    }
    .toast__cta-section > * {
        text-transform: capitalize;
        @include global.a-base();
    }
    .toast__icon--close {
        cursor: pointer;
        position: absolute;
        top: 15px;
        right: 15px;
        height: 18px;
        width: 18px;
    }
    .ns-toast_container[type="fleeting"] .toast__scrim {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        z-index: map.get(other.$otherUtils, z-modal);
        background-color: map.get(other.$otherUtils, global-overlay-background);
        opacity: 0;
        visibility: hidden;
        transition: map.get(other.$otherUtils, global-transition);
    }
    // .ns-toast_container[custom] {
    //     display: none;
    // }
    // .ns-toast_container[custom][opened] {
    //     display: block;
    // }
    .ns-toast_container .custom {
        width: 100%;
    }
    .ns-toast_container[no-top-border] .toast {
        border-top: 0
    }
    // .ns-toast_container[custom] .responsive-container {
    //     display: none;
    // }
    .ns-toast_container[theme="information"] .toast {
        border-color: map.get(colors.$themeColors, color-information);
    }
    .ns-toast_container[theme="success"] .toast {
        border-color: map.get(colors.$themeColors, color-progress);
    }
    .ns-toast_container[theme="warning"] .toast {
        border-color: map.get(colors.$themeColors, color-warning);
    }
    .ns-toast_container[theme="error"] .toast {
        border-color: map.get(colors.$themeColors, color-error);
    }
    .ns-toast_container[theme="exclusive"] .toast {
        border-color: map.get(colors.$themeColors, color-interactive-3);
    }
    @media (min-width: 768px) {
        .responsive-container__inner-container{
            max-width: 600px;
            margin: 0 auto;
            grid-auto-flow: column;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 30px;
        }
    }
    @media (min-width: 1024px) {
        .ns-toast_container {
            .toast{
                transform: translateY(120px);
                min-height: 95px;
            }
            .custom {
                min-height: 95px;
            }
        }
        .ns-toast_container[opened] .toast {
            transform: translateY(0);
        }
    }
    .ns-toast_container[no-icon] .toast__icon--status,
    .ns-toast_container:not([show-close-icon]) .toast__icon--close {
        display: none;
    }

</style>
